import { FC } from 'react';
import { Content } from '@prismicio/client';
import { SliceComponentProps, PrismicRichText } from '@prismicio/react';
import { PrismicNextImage, PrismicNextLink } from '@prismicio/next';

/**
 * Props for `ProcessOverviewCta`.
 */
export type ProcessOverviewCtaProps =
  SliceComponentProps<Content.ProcessOverviewCtaSlice>;

/**
 * Component for "ProcessOverviewCta" Slices.
 */
const ProcessOverviewCta: FC<ProcessOverviewCtaProps> = ({ slice }) => {
  const { visual, title, description, cta_link } = slice.primary;

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="text-white bg-gradient-to-b from-primary-shade-green-dark to-primary-shade-green-darker"
    >
      <div className="container mx-auto px-4 py-20">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div className="w-full">
            <PrismicNextImage
              field={visual}
              className="rounded-lg"
              fallbackAlt=""
            />
          </div>
          <div className="flex flex-col justify-center">
            <div className="text-4xl font-bold mb-6">
              <PrismicRichText field={title} />
            </div>
            <div className="text-lg mb-8">
              <PrismicRichText field={description} />
            </div>
            <div className="flex">
              <PrismicNextLink field={cta_link} className="secondary-button">
                See How AI Powers Delivery
              </PrismicNextLink>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessOverviewCta;
